import React, { useState, useEffect } from 'react'
import {
    Box,
    Typography,
    Card,
    CardContent,
    CardMedia,
    Button,
    Grid,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    useTheme,
    useMediaQuery,
    CircularProgress,
    Alert,
    Divider,
    Container,
    Paper,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Switch,
    FormControlLabel,
    Tabs,
    Tab,
    Modal,

} from '@mui/material';
import {
    Add,
    Edit,
    Delete,
    TableRestaurant,
    People,
    CheckCircle,
    Cancel,
    AccessTime,
    Image,
    Link,
    QrCode,
    ContentCopy,
    OpenInNew,
    Event,
    Person,
    Phone,
    Email,
    Visibility,
    Update,
    Download,
    Store
} from '@mui/icons-material';
import Rating from '@mui/material/Rating';
import { get_all_testimonials, create_testimonial, get_specific_testimonial, update_testimonial } from '../services/testimonialService';
import { useNotification } from '../contexts/NotificationContext';



const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    textAlign: "center"
};

const TestimonialManagement = () => {
    const { showSuccess, showError } = useNotification();

    const [testimonialData, setTestimonialData] = useState([])
    const [modalFields, setModalFields] = useState([
        { 'id': 1, 'label': 'Title' },
        { 'id': 2, 'label': 'Description' },
        { 'id': 3, 'label': 'Customer Name' },
    ])
    const [modalFieldsData, setModalFieldsData] = useState({
        "title": "",
        "description": "",
        "customer_name": "",
        "stars": 0,
    })
    const [modalOpen, setModalOpen] = useState({ type: 'create', value: false })
    const [validationError, setValidationError] = useState({ "label": "", "error": "" })
    const [refreshKey, setRefreshKey] = useState(0);


    useEffect(() => {
        fetchTestimonials();
    }, []);


    const fetchTestimonials = async () => {
        try {
            const response = await get_all_testimonials();
            setTestimonialData(response);
        } catch (error) {
            console.error("Error fetching testimonials =>", error);
        }
    }



    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));


    const handleModalChange = (e) => {
        // console.log(e.target.name + " => " + e.target.value);
        let updateValue = {
            ...modalFieldsData,
            [e.target.name]: e.target.value
        }

        setModalFieldsData(updateValue)
    }

    const submitTestimonial = async (action, id) => {

        setValidationError({ "label": "", "error": "" })

        if (modalFieldsData.title === "") {
            setValidationError({ "label": "Title", "error": "Please Enter Title" })
            return;
        }
        if (modalFieldsData.title !== "" && modalFieldsData.title.length > 80) {
            setValidationError({ "label": "Title", "error": "Please Enter Title less than 80 Characters" })
            return;
        }
        if (modalFieldsData.description === "") {
            setValidationError({ "label": "Description", "error": "Please Enter Description" })
            return;
        }
        if (modalFieldsData.customer_name === "") {
            setValidationError({ "label": "Customer Name", "error": "Please Enter customer name" })
            return;
        }
        if (modalFieldsData.customer_name !== "" && modalFieldsData.customer_name.length > 15) {
            setValidationError({ "label": 'Customer Name', "error": "Please Enter Customer Name Less than 15 characters" })
            return;
        }



        const formData = new FormData();
        formData.append('title', modalFieldsData.title);
        formData.append('description', modalFieldsData.description);
        formData.append('customer_name', modalFieldsData.customer_name);
        formData.append('stars', parseFloat(modalFieldsData.stars));

        if (modalFieldsData.file) {
            formData.append('file', modalFieldsData.file);
        }

        try {
            if (action === 'create') {
                await create_testimonial(formData);
            } else {
                await update_testimonial(formData, id);
            }


            await fetchTestimonials();


            setModalOpen({ ...modalOpen, value: false });
            showSuccess("Testimonial Saved Successfully");
            setModalFieldsData({
                title: "",
                description: "",
                customer_name: "",
                stars: 0,
            });


        } catch (error) {
            showError("Unable to Save Testimonials");
            console.error("Error saving testimonial =>", error);
        }
        setValidationError({ "label": "", "error": "" })
    };


    const editSpecificTestimonial = async (id) => {
        try {
            const response = await get_specific_testimonial(id);
            setModalOpen({ type: 'edit', value: true })
            setModalFieldsData(response)
        }
        catch (error) {
            console.error("Error While Updating testimonial ", error)
        }


    }

    // console.log(modalFieldsData)




    return (

        <Box>
            <Box sx={{
                mb: { xs: 3, sm: 4 },
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', sm: 'center' },
                gap: { xs: 2, sm: 0 }
            }}>
                <Box>
                    <Typography
                        variant={isMobile ? "h5" : "h4"}
                        fontWeight="bold"
                        gutterBottom
                    >
                        Testimonials Management
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Manage your Testimonials
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1, flexDirection: { xs: 'column', sm: 'row' } }}>

                    <Button
                        variant="contained"
                        startIcon={<Add />}
                        onClick={() => setModalOpen({ type: 'create', value: true })}
                        size={isMobile ? "small" : "medium"}

                    >
                        Add Testimonials
                    </Button>
                </Box>
            </Box>

            {testimonialData.length === 0 &&
                <Card sx={{
                    p: 3,
                    pb: 2,
                    textAlign: 'center',
                    bgcolor: '#fff',
                    boxShadow: 1
                }}>
                    <CardContent>
                        <Typography variant="h6" color="text.secondary">
                            No Testimonials Available
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            Create Testimonials to Get Started
                        </Typography>
                    </CardContent>
                </Card>
            }

            {/*  ---------------- Actual Testimonial Data --------------- */}
            {testimonialData.length > 0 &&
                <>
                    <Card>
                        <TableContainer
                            component={Paper}
                            elevation={0}
                            sx={{
                                overflowX: 'auto',
                                '&::-webkit-scrollbar': {
                                    height: '8px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    backgroundColor: 'rgba(0,0,0,0.1)',
                                    borderRadius: '4px',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: 'rgba(0,0,0,0.3)',
                                    borderRadius: '4px',
                                },
                            }}
                        >
                            <Table sx={{ minWidth: 600 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{
                                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                            fontWeight: 600,
                                            minWidth: { xs: '100px', sm: '120px' },
                                            whiteSpace: 'nowrap'
                                        }}>
                                            S.No
                                        </TableCell>
                                        <TableCell sx={{
                                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                            fontWeight: 600,
                                            minWidth: { xs: '80px', sm: '100px' },
                                            whiteSpace: 'nowrap'
                                        }}>
                                            Title
                                        </TableCell>
                                        <TableCell sx={{
                                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                            fontWeight: 600,
                                            minWidth: { xs: '120px', sm: '150px' },
                                            whiteSpace: 'nowrap',
                                            display: { xs: 'none', md: 'table-cell' }
                                        }}>
                                            Stars
                                        </TableCell>
                                        <TableCell sx={{
                                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                            fontWeight: 600,
                                            minWidth: { xs: '120px', sm: '150px' },
                                            whiteSpace: 'nowrap'
                                        }}>
                                            Customer Name
                                        </TableCell>
                                        <TableCell sx={{
                                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                            fontWeight: 600,
                                            minWidth: { xs: '100px', sm: '120px' },
                                            whiteSpace: 'nowrap'
                                        }}>
                                            Action
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {testimonialData.map((items, index) => (
                                        <TableRow hover>
                                            <TableCell sx={{
                                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                whiteSpace: 'nowrap'
                                            }}>
                                                <Typography variant="body2" fontWeight="bold" sx={{
                                                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    {index + 1}
                                                </Typography>
                                            </TableCell>
                                            <TableCell sx={{
                                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                whiteSpace: 'nowrap'
                                            }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Typography variant="body2" sx={{
                                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }}>
                                                        {items.title}
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell sx={{
                                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                whiteSpace: 'nowrap',
                                                display: { xs: 'none', md: 'table-cell' }
                                            }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Typography variant="body2" sx={{
                                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }}>

                                                        <Rating name="half-rating-read" value={items.stars} precision={0.5} readOnly />
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell sx={{
                                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                whiteSpace: 'nowrap'
                                            }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Typography variant="body2" sx={{
                                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }}>
                                                        {items.customer_name}
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                            {/* <TableCell sx={{
                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                        whiteSpace: 'nowrap'
                                    }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Phone sx={{
                                                fontSize: { xs: 14, sm: 16 },
                                                color: 'text.secondary'
                                            }} />
                                            <Typography variant="body2" sx={{
                                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }}>
                                                {order.customer_phone}
                                            </Typography>
                                        </Box>
                                    </TableCell> */}
                                            {/* <TableCell sx={{
                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                        whiteSpace: 'nowrap'
                                    }}>
                                        <Chip
                                            // label={getStatusLabel(order.status)}
                                            // color={getStatusColor(order.status)}
                                            size="small"
                                            sx={{
                                                fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                                height: { xs: '20px', sm: '24px' }
                                            }}
                                        />
                                    </TableCell> */}
                                            {/* <TableCell sx={{
                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                        whiteSpace: 'nowrap',
                                        display: { xs: 'none', sm: 'table-cell' }
                                    }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <AccessTime sx={{
                                                fontSize: { xs: 14, sm: 16 },
                                                color: 'text.secondary'
                                            }} />
                                            <Typography variant="body2" sx={{
                                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }}>
                                                {formatDate(order.created_at)}
                                            </Typography>
                                        </Box>
                                    </TableCell> */}
                                            <TableCell sx={{
                                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                whiteSpace: 'nowrap'
                                            }}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    gap: { xs: 0.5, sm: 1 },
                                                    flexWrap: 'nowrap'
                                                }}>
                                                    <IconButton
                                                        size="small"
                                                        // onClick={() => handleUpdateStatus(order)}
                                                        color="secondary"
                                                        sx={{
                                                            minWidth: { xs: '32px', sm: '40px' },
                                                            height: { xs: '32px', sm: '40px' }
                                                        }}
                                                        onClick={() => editSpecificTestimonial(items.id)}
                                                    >
                                                        <Edit sx={{ fontSize: { xs: 16, sm: 20 } }} />
                                                    </IconButton>
                                                    {/* <IconButton
                                                size="small"
                                                // onClick={() => handleDownloadInvoice(order)}
                                                color="success"
                                                sx={{
                                                    minWidth: { xs: '32px', sm: '40px' },
                                                    height: { xs: '32px', sm: '40px' }
                                                }}
                                                title="Download Kitchen Invoice"
                                            >
                                                <Download sx={{ fontSize: { xs: 16, sm: 20 } }} />
                                            </IconButton> */}
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Card>
                </>}
            {/*  ----------------------- Testimonial Modal ------------------------ */}

            {modalOpen.type === 'create' ?
                <Modal
                    open={modalOpen.value}
                    onClose={() => {
                        setModalOpen({ type: 'create', value: false })
                        setValidationError({ "label": "", "error": "" })
                    }}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: '18px !important',
                                marginBottom: 2,
                            }}
                        >Add Testimonial</Typography>
                        {modalFields.map((fields, index) => {
                            return (
                                <>
                                    <TextField
                                        fullWidth
                                        name={fields.id === 3 ? "customer_name" : fields.label.toLowerCase()}
                                        multiline={fields.id === 2}
                                        rows={fields.id === 2 ? 4 : 1}
                                        label={fields.label === "Customer Name" ? "Customer Name" : fields.label}
                                        value={fields.id === 3 ? modalFieldsData["customer_name"] : modalFieldsData[fields.label.toLowerCase()]}
                                        onChange={(e) => handleModalChange(e)}
                                        sx={{
                                            marginBottom: 2
                                        }}

                                    />
                                    {(validationError.label === fields.label && validationError.error !== "") && <Typography sx={{ color: 'red', mb: 2 }}>{validationError.error}</Typography>}
                                </>
                            )
                        })}

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                            <Typography sx={{ fontWeight: 500 }}>Stars - </Typography>

                            <Rating name="stars" onChange={(e) => handleModalChange(e)} defaultValue={modalFieldsData.stars} precision={0.5} size="large" />
                        </Box>

                        <Button variant='contained' onClick={() => submitTestimonial('create')}>Create Testimonial</Button>

                    </Box>
                </Modal>
                :
                <Modal
                    open={modalOpen.value}
                    onClose={() => {
                        setModalOpen({ type: 'edit', value: false })
                        setValidationError({ "label": "", "error": "" })
                        setModalFieldsData({
                            "title": "",
                            "description": "",
                            "customer_name": "",
                            "stars": 0,
                        })
                    }
                    }
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: '18px !important',
                                marginBottom: 2,
                            }}
                        >Edit Testimonial</Typography>
                        {modalFields.map((fields, index) => {
                            return (<>

                                <TextField
                                    fullWidth
                                    name={fields.id === 3 ? "customer_name" : fields.label.toLowerCase()}
                                    label={fields.label === "Customer Name" ? "Customer Name" : fields.label}
                                    value={fields.id === 3 ? modalFieldsData["customer_name"] : modalFieldsData[fields.label.toLowerCase()]}
                                    onChange={(e) => handleModalChange(e)}
                                    sx={{
                                        marginBottom: 2
                                    }}
                                />
                                {(validationError.label === fields.label && validationError.error !== "") && <Typography sx={{ color: 'red' }}>{validationError.error}</Typography>}
                            </>
                            )

                        })}

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                            <Typography sx={{ fontWeight: 500 }}>Stars - </Typography>

                            <Rating name="stars" onChange={(e) => handleModalChange(e)} defaultValue={modalFieldsData.stars} precision={0.5} size="large" />
                        </Box>

                        <Button variant='contained' onClick={() => submitTestimonial('edit', modalFieldsData.id)}>Update Testimonial</Button>

                    </Box>
                </Modal>


            }



        </Box>
    )
}

export default TestimonialManagement